export default __webpack_public_path__ + "static/media/Sleeve Upper Right.263b6169.jpg";